<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ActivityCard from 'dashboard/components-next/Activities/ActivityCard.vue';

const props = defineProps({
  activities: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['complete', 'edit', 'delete']);

const { t } = useI18n();

const sortedActivities = computed(() => {
  return [...props.activities].sort((a, b) => {
    const dateA = a.dueDate || 0;
    const dateB = b.dueDate || 0;
    return dateB - dateA;
  });
});

const isEmpty = computed(() => sortedActivities.value.length === 0);

const handleComplete = id => emit('complete', id);
const handleEdit = activity => emit('edit', activity);
const handleDelete = activity => emit('delete', activity);
</script>

<template>
  <div class="flex flex-col gap-4">
    <div v-if="isEmpty" class="flex items-center justify-center py-10">
      <span class="text-sm text-slate-500">
        {{ t('DEALS.DETAIL.HISTORY.EMPTY') }}
      </span>
    </div>
    <template v-else>
      <ActivityCard
        v-for="activity in sortedActivities"
        :key="activity.id"
        :activity="activity"
        @complete="handleComplete"
        @edit="handleEdit"
        @delete="handleDelete"
      />
    </template>
  </div>
</template>
